import "./topbar.scss"
import {Person,Mail} from "@material-ui/icons"

export default function Topbar({menuOpen,setMenuOpen}) {
    return (
        <div className={"topbar "+(menuOpen && "active")}>
            <div className="wrapper">
                <div className="left">
                    <a href="#intro" className="logo">Ben3ora.</a>
                    <div className="itemContainer">
                        <Person className="icon"/>
                        <span>0757952055</span>
                    </div>
                    <div className="itemContainer">
                        <Mail className="icon"/>
                        <span><a href="benzoramwenda24@gmail.com" target="_blank">Send Email</a></span>
                    </div>
                </div>

                <div className="right">
                    <div className="hamburger" onClick={()=>setMenuOpen(!menuOpen)}>
                        <span className="line1"></span>
                        <span className="line1"></span>
                        <span className="line1"></span>
                    </div>
                </div>
            </div>
        </div>
    )
}
